import React, { useState, useEffect } from "react";
import Select, { ActionMeta, SingleValue } from "react-select";
import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import { User } from "../models/User";
import index from "@beeldit/core/services";

interface Option {
  label: string;
  value: number | string;
}

function CustomSelectWidget(props: any) {
  const { id, value, required, disabled, readonly, onChange, placeholder, filters } = props;
  const [selectedOption, setSelectedOption] = useState<Option | null>(null);
  const [options, setOptions] = useState<Option[]>([]);
  const [elementsData, setElementsData] = useState({ elements: [] });
  let queryParams = "";
  if (filters) {
    if (filters.role) {
      queryParams = "role=" + filters.role;
    }
  }
  const errorHandler = useErrorHandler();

  useEffect(() => {
    index("users", queryParams)
        .then((response: any) => {
          setElementsData(response.data);
        })
        .catch((error: any) => {
          errorHandler(error, null);
        });
  }, []);

  useEffect(() => {
    const options = elementsData.elements.map((user: User) => {
      return { label: user.name + " (" + user.email + ')', value: user.id };
    });
    setOptions(options);
    const currentSelectedOption = options.find(
      (option) => option.value === value
    );
    setSelectedOption(currentSelectedOption || null);
  }, [elementsData, value]);

  const handleOnChange = (
    newValue: SingleValue<Option>,
    actionMeta: ActionMeta<Option>
  ) => {
    const selectedOption = newValue as Option | null;
    setSelectedOption(selectedOption);
    const model = selectedOption?.value ?? null;
    onChange(model);
  };

  const selectStyles = {
    control: (provided: any) => ({
      ...provided,
      borderColor: "#E7F5F2",
      backgroundColor: "#E7F5F2",
      borderRadius: "0.25rem",
    }),
  };

  return (
    <Select
      id={id}
      options={options}
      value={selectedOption}
      required={required}
      isDisabled={disabled || readonly}
      onChange={handleOnChange}
      styles={selectStyles}
      placeholder={placeholder}
      isClearable={true}
    />
  );
}

function UserSelector(props: any) {
  const { id, options, value, required, disabled, readonly, onChange, placeholder } = props;
  return (
    <CustomSelectWidget
      id={id}
      options={options.enumOptions}
      filters={options.filters}
      placeholder={placeholder}
      value={value}
      required={required}
      disabled={disabled}
      readonly={readonly}
      onChange={onChange}
    />
  );
}

export default UserSelector;
